import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 17.5H20M4 12H20M10 6.5H20" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
		<Path d="M4.75 8V5L6.75 6.5L4.75 8Z" fill="currentColor" vectorEffect="non-scaling-stroke" />
	</SVG>
);
